// The legacy checkout reads installments off a DOM field (a string); the direct link form gets a
// number out of zod. Both funnel through here so the payload always carries a number.
export const normalizeInstallments = (value: string | number): number =>
  typeof value === 'number' ? value : parseInt(value, 10);
